import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as feedbackService from "../../services/feedback.services";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { breakWord, formateDate } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";


const FeedbackView = (props) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: "Feedback",
      url: "/admin/feedback/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    feedbackService
      .Details(params.id)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  {t("btn_view")} {t("sidebar_link_testimonial")}
                </h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>User Name</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.user?.name
                              ? showdefault.user.name
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{"User Profile"}</th>
                          <td>
                            <img
                              src={
                                showdefault && showdefault?.user?.profile_image
                                  ? showdefault.user.profile_image
                                  : "N/A"
                              }
                              alt="profile"
                              style={{ height: "100px" }}
                            />
                          </td>
                        </tr>

                        <tr>
                          <th>Astrologer Name</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.astrologer?.name
                              ? showdefault.astrologer.name
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{"Astrologer Profile"}</th>
                          <td>
                            <img
                              src={
                                showdefault && showdefault?.astrologer?.profile_image
                                  ? showdefault.astrologer.profile_image
                                  : "N/A"
                              }
                              alt="profile"
                              style={{ height: "100px" }}
                            />
                          </td>
                        </tr>

                        <tr>
                          <th>Rating</th>
                          <td>
                            {showdefault && showdefault.rating
                              ? showdefault.rating
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>Feedback</th>
                          <td className="">
                            {showdefault && showdefault.feedback_text
                              ? showdefault.feedback_text
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>

            <div className="mt-5 back-button">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/feedback/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeedbackView;
